import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { PROJECTS } from "../data";

export default function Projects() {
  return (
    <section id="work" data-testid="projects-section" className="relative py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="font-display text-accent text-sm mb-3">Projects & Case Studies</p>
              <h2 className="font-display font-semibold text-3xl md:text-[2.6rem] leading-tight tracking-tight max-w-2xl">
                Selected work, from concept to execution
              </h2>
            </div>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mt-10 md:mt-14">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.06}>
              <Link
                to={`/project/${p.slug}`}
                data-testid={`project-${i}`}
                className="group block card overflow-hidden h-full transition-transform duration-500 hover:-translate-y-1.5"
              >
                <div className="overflow-hidden aspect-[16/10] bg-white flex items-center justify-center p-5">
                  <img
                    src={p.thumb}
                    alt={p.title}
                    className="max-w-full max-h-full object-contain transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-7 md:p-8">
                  <span className="tag mb-4">{p.category}</span>
                  <h3 className="font-display font-semibold text-xl md:text-2xl leading-snug mt-4 group-hover:text-accent transition-colors">
                    {p.title}
                  </h3>
                  <p className="text-ink-soft mt-3 leading-relaxed">{p.summary}</p>
                  <div className="flex flex-wrap gap-2 mt-5">
                    {p.tags.map((t) => (
                      <span key={t} className="text-[13px] font-medium text-ink border border-ink/15 rounded-full px-3.5 py-1.5">{t}</span>
                    ))}
                  </div>
                  <span className="inline-flex items-center gap-2 mt-7 rounded-full bg-ink text-bg px-5 py-2.5 font-display font-medium text-sm group-hover:gap-3 transition-all duration-300">
                    View case study <span aria-hidden>→</span>
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
